<template>
  <v-container
    id="settingsView"
    tag="section"
  >
    <h1>Settings</h1>
    <p>Not implemented yet</p>
  </v-container>
</template>

<script>
  export default {
    name: 'Settings', // this is the name of the component
  }
</script>

<style>
</style>
